import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import authReducer from '../../components/Authorization/authReducer';
import onboardingReducer from '../../components/Onboarding/onboardingReducer';
import appReducer from '../../components/App/appReducer';
import adminDashboardReducer from '../../components/AdminDashboard/adminDashboardReducer';
import membersDashboardReducer from '../../components/MembersDashboard/membersDashboardReducer';

const persistedOnboardingReducer = persistReducer({ key: 'onboarding', storage, whitelist: ['basic'] }, onboardingReducer);
const persistedAppReducer = persistReducer({ key: 'app', storage, blacklist: ['domain'] }, appReducer);

const reducers = combineReducers({
  auth: authReducer,
  onboarding: persistedOnboardingReducer,
  app: persistedAppReducer,
  adminDashboard: adminDashboardReducer,
  members: membersDashboardReducer,
});
const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
